import React, { useState, useMemo, useEffect } from 'react';
import '../candidateRightContentPane/candidateInterestsPanel.css';
import { Card, Container, Row, Col, Button, Form, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye, faPen, faInfoCircle, faPlusCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { CandidatePostLoginService } from '../../../services/candidatePostLoginService';
import CloseIcon from '../../../assets/images/Ic_close.png';
const CandidateInterestsPanel = ({ interests: initialInterests = [] }) => {

  const safeInitialInterests = useMemo(() => Array.isArray(initialInterests) ? initialInterests : [], [initialInterests]);

  const [interests, setInterests] = useState(safeInitialInterests);
  const [modalInterests, setModalInterests] = useState(safeInitialInterests);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setInterests(safeInitialInterests);
    setModalInterests(safeInitialInterests);
  }, [safeInitialInterests]);


  const handleInterestChange = (index, value) => {
    setModalInterests(prev => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });
  };

  // const handleModalAdd = () => {
  //   setModalInterests((prev) => [...prev, '']);
  // };

  const handleModalSave = async () => {
    const cleaned = modalInterests
      .map(item => item.trim())
      .filter(item => item !== '');

    try {
      setLoading(true);
      // await CandidatePostLoginService.submitInterests({ interests: cleaned });
      await CandidatePostLoginService.submitPanelByType('INTERESTS', { interests: cleaned });

      setInterests(cleaned);
      setShowModal(false);
    } catch (error) {
      console.error('Failed to submit interests', error);
      alert('Something went wrong while saving interests.');
    } finally {
      setLoading(false);
    }
  };


  const handleModalAdd = () => setModalInterests(prev => [...prev, '']);
  const handleRemoveInterest = indexToRemove =>
    setModalInterests(prev => prev.filter((_, i) => i !== indexToRemove));

  const handleModalCancel = () => {
    setModalInterests(interests);
    setShowModal(false);
  };


  return (
    <Card className="interestPanel mt-2">
      <Card.Body>
        <Container>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-1">
              <h3 className="mb-0">Interests</h3>
              <div className="interests-tooltip-wrapper">
                <FontAwesomeIcon icon={faInfoCircle} size="sm" style={{ color: '#F35824' }} />
                <div className="interests-tooltip-box">
                  <p>Your interests and hobbies</p>
                </div>
              </div>
            </div>
            <Button
              size="sm"
              variant="link"
              className="p-0"
              onClick={() => {
                setModalInterests(interests);
                setShowModal(true);
              }}
            >
              <FontAwesomeIcon icon={faPen} className="me-1" style={{ color: "#F35824", cursor: 'pointer' }} />
            </Button>
          </div>
          <br />
          <Row>
            {interests.length === 0 ? (
              <Col className="text-muted"></Col>
            ) : (
              interests.map((interest, index) => (
                <Col lg={6} className="label mb-2" key={index}>
                  <FontAwesomeIcon icon={faBullseye} />
                  <span className="p-1">{interest}</span>
                </Col>
              ))
            )}
          </Row>
        </Container>
      </Card.Body>

      <Modal show={showModal} onHide={handleModalCancel} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title>Edit Interests</Modal.Title>
          <img
            src={CloseIcon}
            alt="Close"
            onClick={handleModalCancel}
            style={{
              cursor: 'pointer',
              width: '24px',
              height: '24px',
            }}
          />
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              {modalInterests.map((interest, index) => (
                <Row className="mb-2 align-items-center" key={index}>
                  <Col xs={9}>
                    <Form.Control
                      style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                      type="text"
                      spellCheck='false'
                      value={interest}
                      onChange={(e) => handleInterestChange(index, e.target.value)}
                      placeholder="Interest"
                    />
                  </Col>
                  <Col xs={3} className="text-end">
                    <div
                      size="sm"
                      onClick={() => handleRemoveInterest(index)}
                      style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
                    >
                      <FontAwesomeIcon icon={faMinusCircle} />
                    </div>
                  </Col>
                </Row>
              ))}

              <Col>
                <div
                  size="sm"
                  style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
                  onClick={handleModalAdd}
                >
                  <FontAwesomeIcon icon={faPlusCircle} className="me-1" /> Add Interest
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleModalCancel} className="candidate-profile-edit-cancel">Cancel</button>
          <button
            onClick={handleModalSave}
            className="candidate-profile-edit-save"
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Save'}
          </button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};


export default CandidateInterestsPanel;